'use strict';

import actions from './actions';
import getters from './getters';
import mutations from './mutations';
import DashboardCard from '@/classes/DashboardCard';

const state = {
  defaultDashboard: {
    name: 'Agent Overview',
    cards: [
      new DashboardCard({
        componentName: 'EcsQueueStatusCard'
      }),
      new DashboardCard({
        componentName: 'EcsQueueSummaryCard'
      }),
      new DashboardCard({
        componentName: 'EcsAgentKPICard'
      }),
      new DashboardCard({
        componentName: 'EcsQueueBusinessProcessSummaryCard'
      })
    ]
  },

  selectedDashboard: { cards: [] },

  supervisorDashboards: [
    {
      key: 'adaptive',
      componentName: 'EcsSupervisorInformationCenter'
    },
    {
      key: 'summary',
      componentName: 'EcsBusinessProcessSummaryTable'
    }
  ],

  selectedSupervisorDashboard: 'adaptive'
};

export default {
  namespaced: true,
  actions,
  getters,
  mutations,
  state
};
